module.exports = __webpack_public_path__ + "media/images/ic_bio-3382e9ff.svg";